///line/createLine



import request from '../request'

//查询线路
export function queryLineList() {
    return request({
        url: '/line/queryLineList',
        method: 'get',
        data: {}
    })
}


//删除
export function deleteLine(id) {
    return request({
        url: '/line/deleteLine?id='+id,
        method: 'get',
        data: {}
    })
}

//新建线路
export function createLine(data){
    return request({
        url: '/line/createLine',
        method: 'post',
        data: data
    })
}